import script from "./SpeedAlertSubSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpeedAlertSubSetting.vue?vue&type=script&setup=true&lang=ts"

import "./SpeedAlertSubSetting.vue?vue&type=style&index=0&id=bdfde980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfde980"]])

export default __exports__